import type { NavItem, NavLogo } from "./NavBar.types";

export const defaultItems: NavItem[] = [
  { label: "HPC", href: "https://hmxlabs.io/hpc/" },
  { label: "On-Prem/Cloud", href: "https://hmxlabs.io/hpc/#on-prem-or-cloud" },
  { label: "Cloud Migration", href: "https://hmxlabs.io/hpc/#cloud-migration" },
  { label: "Case Studies", href: "https://hmxlabs.io/hpc/#case-study-cloud-migration" },
  { label: "Community", href: "https://hmxlabs.io/hpc/#hpc-community" },
  { label: "Products & Services", href: "https://hmxlabs.io/hpc/#hpc-products" }
];

export const defaultLogo: NavLogo = {
  logoSrc: "https://hmxlabs.io/assets/img/logo-hpc.png",
  logoAlt: "Logo",
  logoHref: "https://hmxlabs.io/hpc/"
};

export const defaultActiveHref = "https://hmxlabs.io/hpc/";
